import { useCallback } from "react";

import { Switch } from "@/components/ui/button/switch";

import { FormErrorMessage, FormItem, FormLabel } from "../../_base/form";

export type SwitcherFieldProps = {
	value: boolean | undefined;
	handleInput: (e: boolean | undefined) => void;
	disabled?: boolean;

	errorMessage?: string;
	label?: string;
};

export const SwitchField = ({ value, handleInput, disabled = false, errorMessage, label }: SwitcherFieldProps) => {
	const checked = value ?? false;

	const handleCheckedChange = useCallback(
		(checked: boolean) => {
			handleInput(checked);
		},
		[handleInput],
	);

	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>
			<Switch disabled={disabled} className="mt-0" checked={checked} onCheckedChange={handleCheckedChange} />
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
